module.exports = __webpack_public_path__ + "img/企业级安全保障.49650f9e.svg";